import styled from '@emotion/styled/macro';

export default styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  line-height: normal;
`;
